import { truncateString } from "../../../Common/CommonFunctions/TruncateString";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { DropDownPropsTypes } from "../DropDownPropsTypes";
import "../SCSS/styles.css";

function DropDown({
  handleChangeInputDropDown,
  surveyAnswers,
  questionObjVariable,
  questionId,
  isPreview,
  surveyAnswersInfo,
}: DropDownPropsTypes) {
  return (
    <div className="supplier-view-drop-down-cover">
      <select
        disabled={
          // isPreview ||
          surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable
        }
        className="supplier-view-drop-down-select"
        onChange={(e) =>
          surveyAnswersInfo?.surveyStatus !==
            EnumSurveyAnswerStatus?.COMPLETED &&
          !surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable &&
          handleChangeInputDropDown!(questionId, e)
        }
        value={
          surveyAnswers?.[questionId]?.val
            ? `${surveyAnswers?.[questionId]?.val}|${surveyAnswers?.[questionId]?.optionId}`
            : ""
        }
      >
        <option value="" disabled>
          Please select...
        </option>
        {questionObjVariable?.[questionId]?.optionInfo?.optionOrder?.map(
          (optns) => {
            return (
              <option
                data-optionid={optns}
                key={optns}
                className="supplier-view-dropdown-select-option"
                value={`${questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[optns]?.optionName}|${optns}`}
              >
                {truncateString(
                  `${questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[optns]?.optionName}`,
                  50
                )}
              </option>
            );
          }
        )}
      </select>
    </div>
  );
}

export default DropDown;
